import { Button } from "@/components/ui/button";
import { ShoppingCart } from 'lucide-react';
import { useGetOne, useRecordContext } from 'ra-core';
import { useNavigate } from 'react-router';
import type { Project, ProjectVendor } from '../types';

export const CreateProjectDirectPOButton = () => {
    const record = useRecordContext<ProjectVendor>();
    const navigate = useNavigate();

    // Fetch project details to get company_id and reference
    const { data: project } = useGetOne<Project>('projects', { id: record?.project_id }, { enabled: !!record?.project_id });

    if (!record) return null;

    const handleCreate = () => {
        navigate('/purchase_orders/create', {
            state: {
                record: {
                    project_id: record.project_id,
                    vendor_id: record.vendor_id,
                    company_id: project?.company_id,
                    date: new Date().toISOString().split('T')[0],
                    status: 'draft',
                    items: [],
                    comments: `PO created from Project: ${project?.name || record.project_id}. Small order bypass applied if < ₹50,000.`
                }
            }
        });
    };

    return (
        <Button 
            variant="ghost" 
            size="sm" 
            onClick={handleCreate}
            className="h-8 gap-2 text-emerald-600 hover:text-emerald-700 hover:bg-emerald-50 px-2"
            title="Create Direct PO"
        >
            <ShoppingCart className="w-3.5 h-3.5" />
            <span className="text-[10px] font-bold uppercase">Direct PO</span>
        </Button>
    );
};
